import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILocalitiesInitialState, ILocalitiesList, ILocality } from '@types';

import { initialLocalities } from './initialState';

export const localitiesSlice = createSlice({
    name: 'localities',
    initialState: initialLocalities(),
    reducers: {
        setLocalities(state: ILocalitiesInitialState, action: PayloadAction<ILocalitiesList>) {
            state.localitiesList = action.payload;
        },

        setLocality(state: ILocalitiesInitialState, action: PayloadAction<ILocality | null>) {
            state.locality = action.payload;
        },
    },
});
